export default {
  alreadyHaveAccount: "Already have an account? ",
  signUp: "Sign Up"
};
